import { j as p } from "../../../jsx-runtime-B6kdoens.js";
import { useMemo as s } from "react";
import { c as u } from "../../../create-component-CBAeEoQ6.js";
import { CheckboxGroupBase as e } from "../../Checkbox/CheckboxGroup/index.js";
const d = u(
  "RadioButtonGroup",
  ({ onChange: o, ...t }) => {
    const m = s(
      () => o ? (r) => {
        o == null || o(r, r.target.value);
      } : void 0,
      [o]
    );
    return /* @__PURE__ */ p.jsx(
      e,
      {
        onChange: m,
        ...t
      }
    );
  }
);
export {
  d as RadioButtonGroup
};
//# sourceMappingURL=index.js.map
